// Configuration de l'API
const BASES = {
  prod: 'https://scorebook-api.meew.fr',
  preprod: 'http://localhost:8000',
}

// Choisir l'environnement: REACT_APP_API_ENV peut être 'prod' ou 'preprod'
const env = (process.env.REACT_APP_API_ENV || '').toLowerCase()
const defaultEnv = process.env.NODE_ENV === 'development' ? 'preprod' : 'prod'
const selected = env === 'prod' || env === 'preprod' ? env : defaultEnv

export const API_BASE = process.env.REACT_APP_API_BASE || BASES[selected]

/**
 * Construit une URL complète pour l'API
 * @param {string} path - Chemin relatif de l'API
 * @returns {string} URL complète
 */
export const apiUrl = (path) => {
  if (!path) return API_BASE
  // Assurer le slash au début
  return `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`
}

/**
 * Endpoints de l'API
 */
export const API_ENDPOINTS = {
  // Auth
  TOKEN: '/token',

  // Books
  BOOKS: {
    GENRES: '/books/get/genres',
    MY_BOOKS: '/books/get/my-books',
    MY_BOOKS_COUNT: '/books/get/my-books-count',
    SEARCH: '/books/get/search',
    SEARCH_COUNT: '/books/get/search-count',
    CREATE: '/books/create',
    EDIT: (id) => `/books/edit/${id}`,
    DELETE: (id) => `/books/delete/${id}`,
  },

  // Reading list (à lire)
  READING_LIST: {
    GET: '/reading-list/get',
    COUNT: '/reading-list/get/count',
    SEARCH: '/reading-list/get/search',
    SEARCH_COUNT: '/reading-list/get/search-count',
    CREATE: '/reading-list/create',
  },

  // Users
  USERS: {
    MY_PROFILE: '/users/get/my-profile',
    UPDATE_PROFILE: '/users/update/my-profile',
  },

  // Admin
  ADMIN: {
    USERS: '/admin/users',
    USER_ROLE: (id) => `/admin/users/${id}/role`,
    USER_STATUS: (id) => `/admin/users/${id}/status`,
    USER_RESET_PASSWORD: (id) => `/admin/users/${id}/reset-password`,
    GENRES: '/admin/genres',
    GENRE: (id) => `/admin/genres/${id}`,
    AUDIT_LOGS: '/admin/audit-logs',
    SYSTEM_METRICS: '/admin/system/metrics',
    SYSTEM_BACKUP: '/admin/system/backup',
  },
}

/**
 * Construit les paramètres de requête pour la pagination et le tri
 */
export const buildQueryParams = ({ sortBy, order, page, search, ratings, priorities }) => {
  const params = new URLSearchParams()

  if (sortBy) params.set('sort_by', sortBy)
  if (order) params.set('order', order)
  if (page !== undefined) params.set('page', String(page))
  if (search) params.set('q', search)

  if (ratings && Array.isArray(ratings)) {
    ratings.forEach(r => params.append('rating', String(r)))
  }

  if (priorities && Array.isArray(priorities)) {
    priorities.forEach(p => params.append('priority', String(p)))
  }

  return params.toString()
}

const api = {
  API_BASE,
  apiUrl,
  API_ENDPOINTS,
  buildQueryParams,
}

export default api
